import { createSlice } from "@reduxjs/toolkit";
import { subDays } from "date-fns";

const initialState = {
  startDate: subDays(new Date(), 30),
  endDate: new Date(),
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  isEdit: false,
  showCreateModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedId: "",
  isLoading: false,
  showPassword: false,
  totalOrderCount: "",
  excelSendModal: false,
};

const transactionListSlice = createSlice({
  name: "transactionlist",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = transactionListSlice.actions;
export default transactionListSlice.reducer;
